import { coordinateEventName } from '@ui/events'
import { useTapelineStore } from '@editorStores'
import useSelectionMode from './useSelectionMode'

interface Config {
  disableOnCoordinateInputFocused?: boolean
  disableOnTapelineActive?: boolean
}

/**
 * This hook listens to global state and defines whether arbitrary draw
 * controller should be enabled. In general you should use this on any draw
 * controller
 * @returns
 */
const useClickActionEnabled = (
  config: Config = {
    disableOnCoordinateInputFocused: true,
    disableOnTapelineActive: true,
  },
) => {
  const { selectionModeKey } = useSelectionMode()
  const isTapelineActive = useTapelineStore(state => state.isActive)

  if (
    config?.disableOnCoordinateInputFocused &&
    selectionModeKey?.startsWith(coordinateEventName)
  ) {
    return false
  }

  if (config?.disableOnTapelineActive && isTapelineActive) {
    return false
  }

  return true
}

export default useClickActionEnabled
